import React, { useState } from "react";
import BottomSheet from "./BottomSheet";
import { SpotlightIcon, SpotlightIconOff } from "./spotlightIcons";
import "./SpotlightCheckoutBox.css";
import { t } from "../i18n";

// Request Spotlight on the fan's song checkout (only when the talent has it
// on): one box between YOU PAY and the pay buttons — "Show my name / on DJ
// Lucky's screen." — and, on tap, the "Spotlight Display" sheet with the two
// choices. No toggle on the page; nothing else on the checkout changes.

const Chevron = () => (
  <svg width="9" height="15" viewBox="0 0 9 15" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2 2l5 5.5L2 13" />
  </svg>
);
const Check = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
);

type Props = {
  djName: string;
  hidden: boolean;
  onChange: (hidden: boolean) => void;
};

export default function SpotlightCheckoutBox({ djName, hidden, onChange }: Props) {
  const [open, setOpen] = useState(false);
  const pick = (h: boolean) => {
    onChange(h);
    setOpen(false);
  };
  const option = (h: boolean) => {
    const on = hidden === h;
    return (
      <button type="button" role="radio" aria-checked={on} className={`sd-opt${on ? " on" : ""}`} onClick={() => pick(h)}>
        <span className="sd-ic">{h ? <SpotlightIconOff /> : <SpotlightIcon />}</span>
        <span className="sd-text">
          <span className="sd-t">{h ? t("spotlightCheckout.hideMyName") : t("spotlightCheckout.showMyName")}</span>
          <span className="sd-s">{h ? t("spotlightCheckout.hideSub") : t("spotlightCheckout.showSub", { name: djName })}</span>
        </span>
        {on ? (
          <span className="sd-check" aria-hidden="true">
            <Check />
          </span>
        ) : (
          <span className="sd-radio" aria-hidden="true" />
        )}
      </button>
    );
  };
  return (
    <>
      <button type="button" className="rq-spot-box" aria-haspopup="dialog" onClick={() => setOpen(true)}>
        <span className="sb-ic">{hidden ? <SpotlightIconOff /> : <SpotlightIcon />}</span>
        <span className="sb-text">
          <span className="sb-t">{hidden ? t("spotlightCheckout.hideMyName") : t("spotlightCheckout.showMyName")}</span>
          <span className="sb-s">{t("spotlightCheckout.onScreen", { name: djName })}</span>
        </span>
        <span className="sb-chev">
          <Chevron />
        </span>
      </button>
      <BottomSheet open={open} title={t("spotlightCheckout.sheetTitle")} onClose={() => setOpen(false)} plain className="sd-sheet">
        <div className="sd-title-row">
          <span className="sd-title" id="sd-title">
            <span className="sd-title-ic">
              <SpotlightIcon size={26} />
            </span>
            {t("spotlightCheckout.sheetTitle")}
          </span>
          <button type="button" className="bsheet-x" onClick={() => setOpen(false)} aria-label={t("bottomSheet.close")}>
            <svg viewBox="0 0 12 12" width="11" height="11" aria-hidden="true">
              <path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" fill="none" />
            </svg>
          </button>
        </div>
        <div className="sd-body" role="radiogroup" aria-labelledby="sd-title">
          {option(false)}
          {option(true)}
        </div>
      </BottomSheet>
    </>
  );
}
